<template>
  <div style="max-width: 480px; min-width: 350px; margin: 0 auto">
    <div style="padding: 15px 10px; position: relative; padding-bottom: 50px; min-height: 100vh" class="flex-column w100" v-if="ishome">
      <div class="w100 flex">
        <img :src="appInfo.image" alt="" style="width: 125px; height: 125px; border-radius: 10px" />
        <div class="flex-column" style="flex: 1; margin-left: 10px; height: 125px; justify-content: space-around">
          <span style="font-size: 23px">{{ appInfo.ipa_name }}</span>
          <div class="w100">
            <img src="./static/star.png" alt="" style="width: 18px; margin-right: 5px" v-for="star in 5" :key="star" />
          </div>
          <div style="color: #999; font-size: 15px">
            <span>{{ appInfo.ipa_name }}</span>
            <span style="margin-left: 10px">{{ $t('temp8.huobao') }}</span>
          </div>
          <div class="w100 flex">
            <div class="flex" style="align-items: center">
              <img src="./static/gou.png" alt="" style="height: 16px" />
              <span style="color: #38b774; font-size: 13px; margin-left: 3px">{{ $t('temp8.guanfang') }}</span>
            </div>
            <div class="flex" style="align-items: center; margin-left: 7px">
              <img src="./static/gou.png" alt="" style="height: 16px" />
              <span style="color: #38b774; font-size: 13px; margin-left: 3px">{{ $t('temp8.zuobi') }}</span>
            </div>
            <div class="flex" style="align-items: center; margin-left: 7px">
              <img src="./static/gou.png" alt="" style="height: 16px" />
              <span style="color: #38b774; font-size: 13px; margin-left: 3px">{{ $t('temp8.noAd') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 10px; width: 100%; border-radius: 10px; background-color: #666; height: 58px; line-height: 58px; text-align: center" v-if="cannotInstall">
        <span style="color: #fff; font-size: 18px">{{ $t('temp8.safeInstall') }}</span>
      </div>
      <div style="margin-top: 10px; width: 100%; border-radius: 10px; background-color: #38b774; height: 58px; line-height: 58px; text-align: center" @click="installApp(false)" v-else>
        <span style="color: #fff; font-size: 18px" v-if="downloaded">{{ $t('index.back_desktop') }}</span>
        <span style="color: #fff; font-size: 18px" v-else>{{ downloadFlag ? $t('index.installing') : $t('temp8.safeInstall') }}</span>
      </div>

      <div class="w100" style="margin: 15px 0; font-size: 18px" v-if="appInfo.preview">
        {{ $t('index.yy') + $t('index.jt') }}
      </div>
      <div style="padding: 0 0px 0; width: 100%; overflow-x: scroll; overflow-y: hidden; display: flex; flex-wrap: nowrap; margin: 0px auto 0; scrollbar-width: none">
        <img :src="item" style="width: 35%; margin-right: 15px; border-radius: 8px" alt="" v-for="(item, index) in appInfo.preview" :key="index" />
      </div>

      <div class="w100" style="margin: 15px 0; font-size: 18px" v-if="appInfo.logmassage">
        {{ $t('index.yy') + $t('temp7.jianjie') }}
      </div>

      <div style="width: 100%">
        <span style="color: #939393">
          {{ appInfo.logmassage }}
        </span>
      </div>
      <div class="w100" style="position: absolute; bottom: 20px; left: 0; padding: 0 30px">
        <div class="w100" style="height: 40px; line-height: 40px; text-align: center; background-color: #191d3a; margin-top: 25px; border-radius: 5px">
          <span style="color: #fff">Copyright©{{ year }} {{ appInfo.ipa_name }}</span>
        </div>
        <div style="width: 100%; display: flex; justify-content: center; align-items: center; margin: 20px 0 0 0 ">
          <span style="color: #157df1; cursor: pointer" @click="dialogShow = true">{{ $t('index.disclaimer') }}</span>
          <span style="margin: 0 5px;">|</span>
          <span style="color: #157df1; cursor: pointer" @click="report">{{ $t('index.djjb') }}</span>
        </div>
      </div>
    </div>
    <hongbao v-else @back="toggleBack" :appInfo="appInfo" :hongbaoAd="hongbaoAd" :whiteList="whiteList" :jumpObject="jumpObject" />
    <mu-dialog :open.sync="dialogShow" :title="$t('index.disclaimer')" @close="dialogShow = false">
      <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer1') }}</p>
      <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer2') }}</p>
      <p style="padding-top: 20px; font-size: 14px">{{ $t('temp3.disclaimer3') }}</p>
    </mu-dialog>
    <report :baseUrl="baseUrl" :appInfo="appInfo" :appid="appInfo.id || 0" ref="report"></report>
  </div>
</template>

<script>
import report from '../report/report.vue';
import hongbao from './hongbao';
import { mixin } from '../../mixins/mixin.js';
export default {
  components: { report, hongbao },
  mixins: [mixin],
  data() {
    return {
      starList: [
        { star: 5, percentage: 90 },
        { star: 4, percentage: 7 },
        { star: 3, percentage: 0 },
        { star: 2, percentage: 0 },
        { star: 1, percentage: 3 },
      ],
      date: new Date(),
      dialogShow: false,
    };
  },
  computed: {
    year() {
      return this.date.getFullYear();
    },
    today() {
      let month = this.date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = this.date.getDate();
      day = day < 10 ? '0' + day : day;
      return `${this.year}/${month}/${day}`;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}

.tag {
  padding: 2px 10px;
  color: #7195b9;
  font-size: 14px;
  border: 1px solid #c1d2da;
  text-align: center;
  border-radius: 15px;
}

.statisticsBox {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-radius: 16px;
  background: #e5eaed;
  padding: 10px 15px;
}

.bottomBtn {
  position: fixed;
  bottom: 0;
  width: 100%;
  min-height: 130px;
  z-index: 5;
  background: linear-gradient(181deg, #fff0, #fff 46.58%, #fff3);
  display: flex;
  justify-content: center;
}

.installBtn {
  height: 48px;
  width: 250px;
  color: #fff;
  font-size: 16px;
  border-radius: 100px;
  background: #0378fc;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.xinren {
  width: 112px;
  height: 48px;
  color: #0378fc;
  background-color: #fff;
  border-width: 2px;
  border-style: solid;
  border-radius: 100px;
  border: 2px solid #0378fc;
  background: #fff;
  font-size: 16px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
